var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.37492L11.75 2.37492M16.25 5.54159L11.75 5.54159M16.25 8.70825L11.75 8.70825M4.625 10.8915V3.56242C4.625 2.46935 5.46447 1.58325 6.5 1.58325C7.53553 1.58325 8.375 2.46936 8.375 3.56242V10.8915C9.27949 11.5306 9.875 12.6189 9.875 13.8541C9.875 15.8216 8.36396 17.4166 6.5 17.4166C4.63604 17.4166 3.125 15.8216 3.125 13.8541C3.125 12.6189 3.72051 11.5306 4.625 10.8915ZM7.25 13.8541C7.25 14.2913 6.91421 14.6458 6.5 14.6458C6.08579 14.6458 5.75 14.2913 5.75 13.8541C5.75 13.4169 6.08579 13.0624 6.5 13.0624C6.91421 13.0624 7.25 13.4169 7.25 13.8541Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvTemp);
export default __webpack_public_path__ + "static/media/ev-temp.ac395ebe44759c832e21ce1844b5ccbe.svg";
export { ForwardRef as ReactComponent };